import * as React from "react";
import { SyntheticEvent } from "react";
import RaisedButton from "material-ui/RaisedButton";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import { white, primaryText } from "../../colors";
import { Link } from "react-router-dom";

import styles = require("./style.less");
import InternalLink from "../Navigation/InternalLink/InternalLink";

const popoverStyle = {
    backgroundColor: white,
    color: primaryText
};
const menuItemStyle = {
    color: primaryText
};

interface SectionStepLinkProps {
    text: string;
    path: string;
    items: Array<{
        label: string,
        link: string
    }>;
    onNavigating(): void;
}

interface SectionStepLinkState {
    open: boolean;
    anchor: EventTarget;
}

export class SectionStepLink extends React.Component<SectionStepLinkProps, SectionStepLinkState> {
    constructor(props: SectionStepLinkProps) {
        super(props);

        this.state = {
            open: false,
            anchor: null,
        };
    }

    render() {
        if (this.props.items) {
            return (
                <span>
                    <Popover
                        open={this.state.open}
                        style={popoverStyle}
                        canAutoPosition={true}
                        anchorEl={this.state.anchor as any}
                        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                        targetOrigin={{ horizontal: "left", vertical: "top" }}
                        onRequestClose={this.handleRequestClose}>
                        <Menu>
                            {this.props.items.map(item =>
                                <InternalLink key={item.label} to={item.link}>
                                    <MenuItem key={item.label} style={menuItemStyle} primaryText={item.label}
                                        onClick={this.handleNavigate} />
                                </InternalLink>
                            )}
                        </Menu>
                    </Popover>
                    <span className={styles.lookLikeALink} onClick={this.handleTouchTap}>{this.props.text}
                        {this.props.items && <em style={{ paddingLeft: "11px" }} className="fa fa-caret-down" />}
                    </span>
                </span>);
        }

        if (this.props.path) {
            return <InternalLink to={this.props.path}>
                <span className={styles.lookLikeALink} onClick={() => this.handleNavigate()}>{this.props.text}</span>
            </InternalLink>;
        }

        return <span>{this.props.text}</span>;
    }

    private handleNavigate = () => {
        this.setState({
            open: false
        });

        if (this.props.onNavigating) {
            this.props.onNavigating();
        }
    }

    private handleTouchTap = (event: React.SyntheticEvent<{}>) => {
        event.preventDefault();

        this.setState({
            open: true,
            anchor: event.currentTarget
        });
    }

    private handleRequestClose = () => {
        this.setState({
            open: false
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/SectionStepLink.tsx